import * as loadModule from './wasm/web-music-grade';
import { float32ToArrayBuffer, getTimeUnit } from './util';
// 只支持采样深度为16bit
const srcSampleBit = 16;
let Module;
/**
 * 载入 wmg 模块
 */
export async function loadWebMusicGrade() {
    Module = loadModule.default ? await loadModule.default() : await loadModule();
}
export class WebMusicGrade {
    constructor(option) {
        this.pushPitchInfoComplete = false;
        if (option && option.srcSampleRate) {
            option['timeUnit'] = getTimeUnit(option.srcSampleRate);
        }
        // 设置默认值
        this.option = Object.assign({
            timeUnit: getTimeUnit(8000),
            srcSampleRate: 8000,
            srcSampleBit,
            destSampleRate: 8000,
        }, option);
        if (!Module) {
            throw new Error("Have to call load first.");
        }
        this.wmg = new Module.WebMusicGrade(this.option);
        this.pushPitchInfoComplete = false;
    }
    get score() {
        return this._score;
    }
    get bufferScore() {
        return this._bufferScore;
    }
    /**
     * 设置简谱信息
     *  只能设置一次，重新调用前，必须先调用 reInit()
     * @param pitchInfos {WMG.PitchInfo[]} - 简谱信息数组
     */
    setPitchInfos(pitchInfos) {
        if (this.pushPitchInfoComplete) {
            console.warn("The pushPitchInfo completed. Can't call");
            return;
        }
        if (!Array.isArray(pitchInfos)) {
            console.warn("The pitchInfos must be array");
            return;
        }
        pitchInfos.forEach(item => {
            this.wmg.pushPitchInfo(item.pitchNum, item.start, item.end, item.doreNum, item.noteId);
        });
        this.wmg.pushPitchInfoComplete();
        this.pushPitchInfoComplete = true;
    }
    /**
     * 获取当前得分信息
     * @return {WMG.Score} - 当前得分
     */
    getScore() {
        return this._score;
    }
    /**
     * 获取音频段得分
     *  需要持续调用
     * @param buffer - 音频段数据 ArrayBuffer int16 littleEndian
     * @param duration - 音频段持续时长 (s)
     * @return {WMG.Score} - 当前得分
     */
    getSongScore(buffer, duration) {
        if (buffer instanceof Float32Array) {
            buffer = float32ToArrayBuffer(buffer);
        }
        // 检测数据采样率，采样深度，时间与数据长度是否匹配
        if (Math.ceil(this.option.srcSampleRate * srcSampleBit / 8 * duration) !== buffer.byteLength) {
            throw new Error('Length of buffer does not match duration. Make sure the sampling bit is 16 bits');
        }
        this._score = this.wmg.getSongScore(buffer, duration);
        this._bufferScore = this.wmg.getBufferScore();
        return this._score;
    }
    /**
     * 载入用户演奏信息(eur)
     * @param content {string} - eur 文件内容
     * @param partName {string} - 声部名称 P1,P2,P3...
     */
    loadUserPlayInfo(content, partName) {
        const filename = 'load.eur';
        try {
            Module.FS.writeFile(filename, content);
            this.wmg.loadUserPlayInfo(filename, partName);
        }
        catch (e) {
            throw new Error('载入eur文件失败!');
        }
    }
    /**
     * 获取用户演奏信息(eur)
     * @param partName - 声部名称 P1,P2,P3...
     * @return {string} - 用户演奏信息(eur)
     */
    getUserPlayInfo(partName) {
        const filename = 'eur.eur';
        try {
            this.wmg.saveUserPlayInfo(filename, partName);
            return Module.FS.readFile(filename, { encoding: 'utf8' });
        }
        catch (e) {
            throw new Error('获取eur文件失败!');
        }
    }
    /**
     * 获取用户演奏信息(eur) json格式
     *  用于回放
     * @param partName - 声部名称 P1,P2,P3...
     * @return {string} - 用户演奏信息(eur)
     */
    getUserPlayInfoInJson(partName) {
        const filename = 'eur.json';
        try {
            this.wmg.saveUserPlayInfoInJson(filename, partName);
            return Module.FS.readFile(filename, { encoding: 'utf8' });
        }
        catch (e) {
            throw new Error('获取eur文件(json)失败!');
        }
    }
    /**
     * 删除wmg对象 垃圾回收
     */
    delete() {
        if (!this.wmg) {
            return;
        }
        this.wmg.delete();
        this.wmg = null;
    }
}
